export const stylesConfig = {
    sidebar_width: 300,
    info_tooltip_max_width: 500,
    brief_results_dialog_max_width: 600,
    total_brief_results_dialog_max_width: 1000,
};

export default stylesConfig;